import { createRootRoute, Outlet } from "@tanstack/react-router"
import { Component, type ErrorInfo, type ReactNode } from "react"
import { AlertTriangle } from "lucide-react"
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"

export const Route = createRootRoute({
  component: RootLayout,
})

interface ErrorBoundaryState {
  error: Error | null
}

class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Uncaught error:", error, info)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4 p-8 text-center">
          <AlertTriangle className="w-10 h-10 text-destructive" />
          <div>
            <h1 className="text-xl font-semibold mb-1">Something went wrong</h1>
            <p className="text-sm text-muted-foreground max-w-sm">
              An unexpected error occurred. Try refreshing the page.
            </p>
          </div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 text-sm rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            Refresh
          </button>
          {import.meta.env.DEV && (
            <pre className="text-xs text-left bg-muted p-4 rounded-lg max-w-xl overflow-auto mt-2 text-destructive">
              {this.state.error.message}
            </pre>
          )}
        </div>
      )
    }
    return this.props.children
  }
}

function RootLayout() {
  return (
    <ErrorBoundary>
      <Outlet />
      {/* <TanStackRouterDevtools position="bottom-right" /> */}
    </ErrorBoundary>
  )
}
